import axios from 'axios';

// URL base de la API por entorno: VUE_APP_API_URL se define en .env.production
// (build de producción) y el fallback aplica en desarrollo (npm run serve).
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:3010';

const AUTH_STORAGE_KEYS = ['token', 'userRole', 'userId', 'userName', 'businessId', 'businessName', 'mustChangePassword'];

function clearAuthSession() {
  AUTH_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
}

axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    const isLoginRequest = requestUrl.includes('/api/auth/login');

    if (status === 401 && !isLoginRequest) {
      clearAuthSession();

      const path = window.location.pathname;
      if (path !== '/login' && path !== '/change-password') {
        window.location.replace('/login');
      }
    }

    return Promise.reject(error);
  }
);

export default axios; 